const initailState = {
  arr: [],
  arrsearch: [],
  nextKey: "",
};
const AccountsCollectionRides = (state = initailState, action) => {
  switch (action.type) {
    case "ADD_COLLECTION_RIDES_DATA":
      return {
        arr: state.arr.concat(action.payload),
        nextKey: action.nextKey,
        arrsearch: [],
      };
    case "ADD_COLLECTION_RIDES_SEARCH_DATA":
      return { ...state, arrsearch: action.payload };
    default:
      return state;
  }
};

export default AccountsCollectionRides;
